/**
 * Formats a US phone number for display.
 *
 * Output format:
 *
 * - 10 digits: XXX-XXX-XXXX
 * - > 10 digits: XXX-XXX-XXXX x EXT
 */
export function formatPhoneNumber(value: string | null | undefined): string {
  if (value == null) {
    return '';
  }

  const trimmed = value.trim();
  if (!trimmed || isPlaceholderValue(trimmed)) {
    return trimmed;
  }

  const digits = trimmed.replace(/\D/g, '');
  if (!digits) {
    return trimmed;
  }

  if (digits.length <= 3) {
    return digits;
  }

  if (digits.length <= 6) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  const basePhone = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  if (digits.length <= 10) {
    return basePhone;
  }

  return `${basePhone} x ${digits.slice(10)}`;
}

function isPlaceholderValue(value: string): boolean {
  const normalized = value.toUpperCase();
  return normalized === 'NA' || normalized === 'N/A' || normalized === '-';
}
